import React from "react";
import { Routes, Route } from "react-router-dom";
import { NewAssistance3d } from "../pages/assistance";

export function Assistance3dRouter() {
  return (
    <Routes>
      {/* Ruta con parámetro dinámico :assistantId */}
      <Route path=":assistantId" element={<NewAssistance3d />} />
    </Routes>
  );
}
